import { render, staticRenderFns } from "./what-is-modal.vue?vue&type=template&id=15ae991b&lang=pug"
import script from "./what-is-modal.vue?vue&type=script&lang=js"
export * from "./what-is-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports